import React from 'react';
import { shape, string, number } from 'prop-types';
import RichText from '../RichText';
import RichContent from '../RichContent';

/**
 * YDWidget component.
 *
 * @typedef YDWidget
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a YD Widget.
 */
const YDWidget = ({ item }) => <RichContent html={item.html} />;

/**
 * Props for {@link YDWidget}
 *
 * @typedef props
 *
 * @property {String} content Rich content of the block
 */
/*
YDWidget.propTypes = {
    item: shape({
		id: number,
		title: string,
		html: string.isRequired
	})
};
*/

/**
 * Props for {@link YDWidget}
 *
 * @typedef props
 *
 * @property {Object} classes An object containing the class names for the YDWidget
 * @property {String} html Content
 */
YDWidget.propTypes = {
    html: string
};

export default YDWidget;
